import { render, staticRenderFns } from "./Tick.vue?vue&type=template&id=407ce492&scoped=true"
import script from "./Tick.vue?vue&type=script&lang=js"
export * from "./Tick.vue?vue&type=script&lang=js"
import style0 from "./Tick.vue?vue&type=style&index=0&id=407ce492&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407ce492",
  null
  
)

export default component.exports